module.exports = __webpack_public_path__ + "static/media/sup_csc.50153fbf.png";